import { LaborRateMode, LaborRateProfile } from '@/app/types/labor-rate';
import { ApiClient, ApiClientProps } from './client';

export type LaborDifficulty = 'custom' | 'normal' | 'hard' | 'very_hard';

export type Organization = {
  id: number;
  name: string;
  labor_base_rate: string;
  default_labor_rate_mode: LaborRateMode;
  default_labor_rate_profile: LaborRateProfile;
  use_my_pricing: boolean;
  show_issue_estimated_impact: boolean;
  project_creator_enabled?: boolean;
  labor_difficulty: LaborDifficulty;
  custom_labor_modifier: string;
  material_markup_percent: string;
  labor_markup_percent: string;
  general_admin_expense_rate: string;
  sales_tax_rate: string;
  risk_insurance_rate: string;
  profit_margin_rate: string;
  created_at: string;
  updated_at: string;
};

export type OrganizationUpdateRequest = {
  labor_base_rate?: string;
  default_labor_rate_mode?: LaborRateMode;
  default_labor_rate_profile?: LaborRateProfile;
  use_my_pricing?: boolean;
  show_issue_estimated_impact?: boolean;
  labor_difficulty?: LaborDifficulty;
  custom_labor_modifier?: string;
  material_markup_percent?: string;
  labor_markup_percent?: string;
  general_admin_expense_rate?: string;
  sales_tax_rate?: string;
  risk_insurance_rate?: string;
  profit_margin_rate?: string;
};

/**
 * API client for organization-related endpoints
 */
export class OrganizationsClient extends ApiClient {
  constructor(props: ApiClientProps) {
    super(props);
  }

  update = async (id: number, data: OrganizationUpdateRequest) => {
    return this._patch<Organization>(`organizations/${id}/`, data);
  };
}
